module.exports = __webpack_public_path__ + "static/media/Home.47aac6e6.png";